import { render, staticRenderFns } from "./PollutionalertsFormHeaderModal.vue?vue&type=template&id=612cc523"
import script from "./PollutionalertsFormHeaderModal.vue?vue&type=script&lang=js"
export * from "./PollutionalertsFormHeaderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports